import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { templatesService } from '../api/templates.service';
import { TEMPLATE_KEYS } from './queryKeys';

export function useTemplate(templateId: string) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  const { data, isLoading, isError } = useQuery({
    queryKey: TEMPLATE_KEYS.detail(orgId ?? '', templateId),
    queryFn: ({ signal }) => templatesService.getById(templateId, signal),
    staleTime: 60_000,
    enabled: !!orgId && !!templateId,
  });

  return {
    template: data?.data,
    isLoading,
    isError,
  };
}
